import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-coach-groups-dropdown',
  templateUrl: './coach-groups-dropdown.component.html',
  styleUrls: ['./coach-groups-dropdown.component.scss'],
})
export class CoachGroupsDropdownComponent implements OnInit {
  @Input() items: any[];
  @Input() opened = false;
  constructor() { }

  ngOnInit() {
  }

  changeSvgWidth() {
      const ionCheckboxes = document.querySelectorAll('ion-checkbox');
      ionCheckboxes.forEach((el) => {
          el.shadowRoot.querySelectorAll('.checkbox-icon').forEach((icon) => {
              icon.setAttribute('style', 'width: 18px');
          })
      })

  }

}
